import React from 'react'
import PageWrapper from '../Components/Other/PageWrapper'
import { useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { routes } from '../MainPage'
import { useSelector } from 'react-redux'
import PageBanner from '../Components/Other/PageBanner'
import moment from 'moment';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper';
function EventInfo(props) {
    let { name } = useParams();
    let navigate = useNavigate();
    let location = useLocation()
    location.state == null && navigate(routes.home)
    const { description, event_date, event_image, title, update_date } = location.state == null ? {} : location.state
    var imagesArr = event_image.split(',')
    useEffect(() => {
        location.state == null && navigate(routes.blog)
    }, [location])

    const slides = [];
    imagesArr.forEach(async (item, idx) => {
        await slides.push(
            <SwiperSlide className="swiper-slide" >
                <img src={item} alt="Blog" />
            </SwiperSlide>
        );
    });
    return (
        <PageWrapper className={"blog-page"}>
            <div className="pageWrapper">
                <PageBanner pageName={"Event Information"}></PageBanner>
                <div className="MainContent">
                    <div className="container">
                        <div className="blog-content">
                            <div className="container blog-container">
                                <div className="blog-details">
                                    <h2>{title}</h2>
                                    <div className="blog-date">
                                        <span>{moment(event_date).format('MMM Do, YYYY')}</span>
                                    </div>
                                </div>
                                <div className="article-post-imgtxt">
                                    {event_image != "" && <Swiper
                                        modules={[Navigation, Pagination,]}
                                        className="article-post-img"
                                        spaceBetween={0}
                                        slidesPerView={1}
                                        effect={"slide"}
                                        autoHeight={true}
                                        pagination={{
                                            clickable: true,
                                        }}
                                    >
                                        <SwiperSlide className="swiper-slide" >
                                            <img src={event_image != "" ? event_image : require('../img/evnetPlaceHolder.png')} alt="Blog" />
                                        </SwiperSlide>
                                    </Swiper>}

                                </div>
                                <div className="blog-long-des" dangerouslySetInnerHTML={{ __html: description }}></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </PageWrapper>
    );
}

export default EventInfo;